import * as React from 'react';

import styles from './Header.module.scss';
import HeaderBar from './HeaderBar';
import { HeaderProps } from './types';

const Header: React.FC<HeaderProps> = ({
  title,
  headingElement = 'h1',
  backButtonText,
  backButtonHidden,
  onBackButtonClick,
  headerBackground,
  visible = true,
}) => {
  if (!visible) return null;
  return (
    <div className={styles.header}>
      <HeaderBar
        heading={title}
        headingElement={headingElement}
        headerBackground={headerBackground}
        backButtonText={backButtonText}
        onBackButtonClick={onBackButtonClick}
        backButtonHidden={backButtonHidden}
      />
    </div>
  );
};

export default Header;
